export default __webpack_public_path__ + "static/media/Hellfury Robe.fe53b4a7.jpg";